import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class NewVersionConfirmationService {
    public showDialog = new BehaviorSubject<boolean>(false);
    public version = new BehaviorSubject<string>('');
}
